import { Box } from '@wix/design-system';
import {
  Faq,
  HeaderBanner,
  useAnonymous,
  useIsSeasonalSale,
} from '@wix/package-picker-shared-studio';
import { NavigationButton } from '@wix/premium-purchase-platform/@ui';
import classNames from 'classnames';
import React from 'react';
import { StudioPackagePickerModule } from '../../modules/studio-package-picker.module';
import { Header } from '../Header/Header';
import { PageFooter } from '../PageFooter/PageFooter';
import { SaleBanner } from '../SaleBanner';
import s from './PageLayout.scss';

type PageLayoutProps = {
  children: React.ReactNode;
} & (
  | { onBack: () => void; backButtonText: string }
  | { onBack?: never; backButtonText?: never }
);

export const PageLayout = ({
  children,
  onBack,
  backButtonText,
}: PageLayoutProps) => {
  const { t, Trans } = StudioPackagePickerModule.internals.useTranslations();
  const { isAnonymous } = useAnonymous();
  const isSeasonalSale = useIsSeasonalSale();

  return (
    <Box
      direction="vertical"
      width="100%"
      align="center"
      marginBottom={isAnonymous ? '' : 'SP5'}
    >
      <Box width="100%" marginBottom={isSeasonalSale ? '' : 'SP2'}>
        {!isAnonymous && <HeaderBanner shouldShowSwitchPlanBanner />}
      </Box>
      {/* Seasonal sale: banner sits under the logo per Figma 1:15228, with
          18px below it. When inactive, SaleBanner renders nothing — the
          non-sale DOM stays byte-identical to master. */}
      {isSeasonalSale && (
        <Box width="100%" marginBottom="SP3">
          <SaleBanner />
        </Box>
      )}
      <Box>
        {onBack && (
          <NavigationButton
            onClick={onBack}
            text={backButtonText}
            direction="back"
            className={classNames(
              s.backButton,
              isSeasonalSale && s.backButtonWithSale,
            )}
            isVisible={true}
          />
        )}
        <Header />
      </Box>
      <Box
        width="100%"
        align="center"
        direction="vertical"
        maxWidth="1140px"
        marginBottom="SP7"
      >
        {children}
      </Box>
      <Faq t={t} Trans={Trans} />
      <PageFooter />
    </Box>
  );
};
